import React from "react";
import { UserHelper, ApiHelper, ArrayHelper } from "../helpers";
import { Link, useLocation } from "react-router-dom";
import UserContext from "../UserContext";


export const Header = () => {
  const location = useLocation();

  const [showMenu, setShowMenu] = React.useState(false);

  const handleMenuClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setShowMenu(!showMenu);
  }

  const context = React.useContext(UserContext);

  const pickDepartment = (departmentId: number) => {
    UserHelper.currentDepartment = ArrayHelper.getOne(UserHelper.departments, "id", departmentId);
    ApiHelper.setDefaultPermissions(UserHelper.currentDepartment.jwt);
    UserHelper.departmentChanged = true;
    context.setUserName(UserHelper.currentDepartment.id.toString());
  }

  const getDepartmentMenu = () => {
    if (showMenu) {
      const accountList: React.ReactElement[] = [];
      UserHelper.departments.forEach(d => {
        const departmentId = d.id;
        accountList.push(<a href="about:blank" onClick={(e) => { e.preventDefault(); pickDepartment(departmentId) }}><i className="fas fa-user"></i> {d.name}</a>);
      });

      return (<div id="userMenu" data-testid="user-dropdown-menu">
        <div className="label divider">Switch Account</div>
        <div id="userAccounts" data-testid="account-list">{accountList}</div>
        <Link to="/settings/" data-testid="settings-link"><i className="fas fa-cog"></i> Settings</Link>
        <Link to="/logout" className="divider" data-testid="logout-link"><i className="fas fa-lock"></i> Logout</Link>
      </div>);
    }
  }


  const getHeaderLink = () => {
    return (<a href="about:blank" onClick={handleMenuClick}>
      <i className="fas fa-user"></i> &nbsp;
      {UserHelper.currentDepartment.name} &nbsp;
      <i className="fas fa-caret-down"></i>
    </a>)
  }

  React.useEffect(() => { if (showMenu) setShowMenu(false) }, [location.pathname]) //eslint-disable-line

  return (
    <>
      <nav id="pageHeader" className="navbar navbar-expand navbar-dark fixed-top bg-dark" data-testid="page-header">
        <a className="navbar-brand" href="/" style={{ paddingTop: 0, paddingBottom: 0 }} data-testid="logo-link"><img src="/images/logo.png" style={{ paddingTop: 0, paddingBottom: 0 }} alt="logo" /></a>
        <div className="collapse navbar-collapse" id="navbar">
          <ul className="navbar-nav mr-auto">
          </ul>
          <div className="navbar-nav ml-auto" data-testid="user-menu-toggle">
            {getHeaderLink()}
          </div>
        </div>
      </nav>
      {getDepartmentMenu()}
      <div style={{ height: 66 }}></div>
    </>
  );
};